import React, { useEffect } from 'react';
import { Spinner } from '../../../../common';
import RolesTable from './RolesTable.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGetRolesQuery } from '../../../../../redux/services/roles';

const RolesPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: roles } = useGetRolesQuery();

  useEffect(() => {
    document.title = t('Role') + ' - FRI CMS';
  }, [t]);

  if (!roles) {
    return <Spinner />;
  }

  return (
    <>
      <AppBarCMS
        title={t('Role')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        permissionsBasic={'roles'}
      />
      <div style={{ margin: '10px' }}>
        <RolesTable
          roles={roles}
          onDetailClick={(id) => navigate(`${routes.cmsRolesDetail}/${id}`)}
        />
      </div>
    </>
  );
};

export default RolesPage;
